<template>
  <nav
    class="main-header navbar navbar-expand navbar-white navbar-light"
    style="z-index: 1 !important"
  >
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <!-- Boton hamburgesa -->
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"
          ><i class="fas fa-bars"></i
        ></a>
      </li>

      <!-- Indicador de Semana -->
      <li class="nav-item">
        <fecha-component style="padding: 0.2rem 1rem" />
      </li>

      <!-- Separador vertical -->
      <div style="width: 1px; background: #c2c2c2; height: 55px"></div>


      <!-- MENUS DE OPCIONES BARRA SUPERIOR -->

        <!-- Top menu para Buscar reservas -->
        <buscar-reserva/>
        <!-- Top Booking menu -->
        <top-booking-menu v-if="seccion_actual == 'booking'" class="ml-2" />

        <!-- Top Shipping menu -->
        <agregar-shipping-instructions-modal 
          v-if="sub_seccion_actual == 'shipping-instructions' || sub_seccion_actual == 'si'"
          class="ml-3 mt-2 mr-3"
        />

        <reporte-shipping-instructions
          v-if="(sub_seccion_actual == 'shipping-instructions') && (usuarioActual.id_role === 9999 || usuarioActual.id_role === 1)">
        </reporte-shipping-instructions>

      <tracking-short-cut></tracking-short-cut>


    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto mr-3">
      <!-- Modal nueva reserva -->
      <li class="nav-item"></li>

      <!-- Modal Itinerarios -->
      <!-- <li class="nav-item">
        <busqueda-itinerarios-modal />
      </li> -->

      <!-- Nacionalidad -->
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown">
          <i class="flag-icon" :class="bandera" :title="usuarioActual.filial"></i>
        </a>
      </li>

      <!-- Logout -->
      <li class="nav-item dropdown">
        <a
          class="nav-link"
          style="cursor: pointer"
          title="Cerrar sesión"
          aria-expanded="false"
          @click="cerrarSesion"
        >
          <i class="fas fa-sign-out-alt"></i>
        </a>
        <!-- Navbar Search -->
      </li>
    </ul>
  </nav>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

// import NuevaReservaModal from "../modals/NuevaReservaModal";
import FechaComponent from "./FechaComponent";
import TopBookingMenu from "./TopBookingMenu";

// import BusquedaItinerariosModal from "../modals/lineas/BusquedaItinerariosModal";
import AgregarShippingInstructionsModal from "../modals/shippinginstructions/AgregarShippingInstructionsModalMenuSuperior";
import BuscarReserva from '../modals/BuscarReserva';
import ReporteShippingInstructions from "@/components/modals/shippinginstructions/ReporteShippingInstructions.vue";
import TrackingShortCut from "@/components/busqueda/lineas/TrackingShortCut.vue";

// Vuex

export default {
  components: {
    // NuevaReservaModal,
    FechaComponent,
    TopBookingMenu,
    AgregarShippingInstructionsModal,
    BuscarReserva,
    ReporteShippingInstructions,
    TrackingShortCut,
  },

  computed: {
    ...mapState(["seccion_actual","sub_seccion_actual","usuarioActual"]),
    ...mapState("modulosLogin", ["isShipping"]),
  },

  data() {
    return {
      bandera: '',
      usuarioLogueado : ''
    }
  },
  methods: {
    // Vuex
    ...mapActions(["AccionCerrarSesion"]),

    cerrarSesion() {
      this.AccionCerrarSesion();
    },

  },

  mounted(){

      switch (this.usuarioActual.filial) {

        case 'UCC Chile':
            this.bandera = 'flag-icon-cl';
          break;

        case 'UCC Perú':
            this.bandera = 'flag-icon-pe';
          break;

        case 'UCC Costa Rica':
            this.bandera = 'flag-icon-cr';
          break;

        case 'UCC Colombia':
            this.bandera = 'flag-icon-co';
          break;

        case 'UCC USA':
            this.bandera = 'flag-icon-us';
          break;

        case 'UCC España':
            this.bandera = 'flag-icon-es';
          break;
      
      }


  }
  

};
</script>

<style>
.nav NuevaReservaModalbar button {
  color: #fff !important;
}

.badge {
  color: #000 !important;
}
</style>
